// OBT F3-E — Panel başlığındaki bildirim zili (okunmamış rozetli buton).
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useObtUnreadCount } from './hooks/useObtUnreadCount';

export default function ObtNotificationBell({ enabled = true, onClick }) {
  const { count } = useObtUnreadCount({ enabled });
  return (
    <Button variant="outline" onClick={onClick} className="relative" aria-label={`Bildirimler${count > 0 ? `, ${count} okunmamış` : ''}`}>
      <Bell className="mr-2 h-4 w-4" aria-hidden="true" />
      Bildirimler
      {count > 0 && (
        <span className="ml-2 inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-red-600 px-1.5 py-0.5 text-xs font-bold text-white">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Button>
  );
}
